module.exports = __webpack_public_path__ + "static/media/icons.ae694ff7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/svg/icons.svg
// module id = 807
// module chunks = 0